import { useEffect, useState } from "react";
import { getAppointmentStatuses } from "../../api/appointmentService";

export const useAppointmentStatuses = (trigger, emptyCallback) => {
  const [statuses, setStatuses] = useState({});
  const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAppointmentStatuses()
            .then((statuses) => {
                setStatuses(statuses);
                if (emptyCallback && statuses.length === 0) {
                    emptyCallback(true);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch appointment statuses:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [trigger]);

  return { statuses, loading, setStatuses };
};
